import { appConfigIds } from "@constants/common";
import { buildType } from "@helpers/expo-extras";
import useClerkUser from "./useClerkUser";

const useAppConfigIds = () => {
	const { userPublicMetadataId } = useClerkUser();
	const collectionId = appConfigIds[buildType].collectionId;
	const projectId = appConfigIds[buildType].projectId;
	const organizationId = appConfigIds[buildType].organizationId;
	const productId = appConfigIds[buildType].productId;
	const productUuid = appConfigIds[buildType].productUuid;
	const userId = userPublicMetadataId!;

	return {
		collectionId,
		projectId,
		organizationId,
		userId,
		productId,
		productUuid,
	};
};

export default useAppConfigIds;
